import { BigNumber } from 'ethers';

const properties = require('@ethersproject/properties');

// generator function
export const asyncGeneratorStep = (gen, resolve, reject, _next, _throw, key, arg) => {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }

    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
};

// generator function
export const asyncToGenerator = (fn) => {
    return function () {
        const self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
            }

            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
            }

            _next(undefined);
        });
    };
};

export const checkError = (error) => {
    if (error.statusText === 'INS_NOT_SUPPORTED') {
        error.message =
            'Device is not supported. Make sure the Ethereum app is open on the device.';
    }

    if (error.statusText === 'UNKNOWN_ERROR') {
        error.message =
            'Unknown error. Make sure the device is connected and the Ethereum app is open on the device.';
    }

    if (error.statusText === 'CONDITIONS_OF_USE_NOT_SATISFIED') {
        error.message = 'User rejected the request';
    }

    throw error;
};

export const toNumber = (value) => {
    return value == null ? undefined : BigNumber.from(value).toNumber();
};

export function _extends() {
    const extend =
        Object.assign ||
        function (target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];

                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }

            return target;
        };

    return extend.apply(this, arguments);
}

const hasEIP1559 = (tx) => {
    return tx.type === 2 || tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
};

export const convertToUnsigned = /*#__PURE__*/ (function () {
    var _ref = /*#__PURE__*/ asyncToGenerator(function* (tx) {
        var resolvedTx = yield properties.resolveProperties(tx);
        var { chainId, data, gasLimit, gas, gasPrice, value, to } = resolvedTx;
        var nonce = toNumber(resolvedTx.nonce);
        var type = toNumber(resolvedTx.type); // Allowed transaction keys for Legacy and EIP-155 Transactions

        var baseTx = {
            gasLimit: gasLimit || gas,
            type: type != null ? type : 2,
            chainId,
            gasPrice,
            nonce,
            value,
            data,
            to,
        }; // EIP-2930

        if (tx.accessList != null) {
            baseTx.accessList = tx.accessList;
        } // EIP-1559

        if (hasEIP1559(tx)) {
            baseTx.maxFeePerGas = tx.maxFeePerGas;
            baseTx.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
            baseTx.type = 2;
        }

        return baseTx;
    });

    return function convertToUnsigned(_x) {
        return _ref.apply(this, arguments);
    };
})();

export const isHIDSupported = () => {
    try {
        return 'hid' in window.navigator;
    } catch (error) {
        return false;
    }
};
